import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function ProjectsPage() {
  const [showPavillonForm, setShowPavillonForm] = useState(false);
  const [showAfversosoForm, setShowAfversosoForm] = useState(false);
  const [pavillonFormData, setPavillonFormData] = useState({
    nom: '',
    structure: '',
    activite: '',
    surface: '',
    contact: '',
    besoins: '',
    message: ''
  });
  const [afversosoFormData, setAfversosoFormData] = useState({
    nom: '',
    structure: '',
    activite: '',
    surface: '',
    contact: '',
    besoins: '',
    message: ''
  });
  const [pavillonSubmitting, setPavillonSubmitting] = useState(false);
  const [afversosoSubmitting, setAfversosoSubmitting] = useState(false);
  const [pavillonSuccess, setPavillonSuccess] = useState(false);
  const [afversosoSuccess, setAfversosoSuccess] = useState(false);

  const handlePavillonSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setPavillonSubmitting(true);
    try {
      const formData = new URLSearchParams();
      Object.entries(pavillonFormData).forEach(([key, value]) => { formData.append(key, value); });
      const response = await fetch('https://readdy.ai/api/form/submit/pavillon-afrique-info', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData
      });
      if (response.ok) {
        setPavillonSuccess(true);
        setPavillonFormData({ nom: '', structure: '', activite: '', surface: '', contact: '', besoins: '', message: '' });
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
    } finally {
      setPavillonSubmitting(false);
    }
  };

  const handleAfversosoSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setAfversosoSubmitting(true);
    try {
      const formData = new URLSearchParams();
      Object.entries(afversosoFormData).forEach(([key, value]) => { formData.append(key, value); });
      const response = await fetch('https://readdy.ai/api/form/submit/festival-afversoso-stand', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formData
      });
      if (response.ok) {
        setAfversosoSuccess(true);
        setAfversosoFormData({ nom: '', structure: '', activite: '', surface: '', contact: '', besoins: '', message: '' });
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi:', error);
    } finally {
      setAfversosoSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative bg-gradient-to-r from-orange-500 to-red-600 text-white py-20">
          <div className="absolute inset-0 bg-black/20"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6">Nos Projets Phares</h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              Découvrez nos réalisations emblématiques qui célèbrent la richesse culturelle africaine
            </p>
          </div>
        </section>

        {/* Pavillon Afrique Section */}
        <section id="pavillon-afrique" className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Pavillon Afrique</h2>
                <h3 className="text-xl text-orange-600 font-semibold mb-4">Foire Internationale de Nantes</h3>
                <p className="text-lg text-gray-700 mb-6">
                  Une vitrine exceptionnelle de la culture africaine au coeur de la Foire Internationale de Nantes.
                  Le Pavillon Afrique rassemble artisans, créateurs et entrepreneurs pour célébrer la diversité
                  et l'excellence du continent africain.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-store-2-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Stand d'exposition</h4>
                      <p className="text-gray-600">Un coin d'Afrique avec des créations durables et authentiques</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-restaurant-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Stand restauration</h4>
                      <p className="text-gray-600">Saveurs d'Afrique : un voyage culinaire authentique</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-calendar-event-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Événements culturels</h4>
                      <p className="text-gray-600">Animations, spectacles et rencontres avec les créateurs</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-3">
                    <div className="w-6 h-6 flex items-center justify-center">
                      <i className="ri-group-line text-orange-600 text-xl"></i>
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-900">Networking</h4>
                      <p className="text-gray-600">Rencontres entre entrepreneurs et créateurs africains</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg shadow-md mb-6">
                  <h4 className="font-semibold text-gray-900 mb-3">Prochaine édition</h4>
                  <div className="flex items-center space-x-4 text-sm text-gray-600">
                    <div className="flex items-center space-x-2">
                      <i className="ri-calendar-line text-orange-600"></i>
                      <span>2 au 6 Avril 2026</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-time-line text-orange-600"></i>
                      <span>18h30</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <i className="ri-map-pin-line text-orange-600"></i>
                      <span>Parc des Expositions de Nantes</span>
                    </div>
                  </div>
                </div>
                <div className="flex space-x-4">
                  <a
                    href="https://www.instagram.com/lepavillonafrique/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-orange-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Suivre sur Instagram
                  </a>
                  <button
                    onClick={() => setShowPavillonForm(true)}
                    className="border border-orange-600 text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-orange-50 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Besoin d'infos
                  </button>
                  <a
                    href="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Formulaire%20d'inscription%20Pavillon%20Afrique/1%20%20Fiche%20d'admission%202026.pdf?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJGb3JtdWxhaXJlIGQnaW5zY3JpcHRpb24gUGF2aWxsb24gQWZyaXF1ZS8xICBGaWNoZSBkJ2FkbWlzc2lvbiAyMDI2LnBkZiIsImlhdCI6MTc2NjEzMTMxNSwiZXhwIjoxNzk3NjY3MzE1fQ.tOopjr6jpTLJmSfipqJYpBuk0SqKfho323z0SLibbtI"
                    download="Fiche_admission_Pavillon_Afrique_2026.pdf"
                    className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer flex items-center"
                  >
                    <i className="ri-download-line mr-2"></i>
                    Télécharger le dossier
                  </a>
                </div>
              </div>
              <div className="space-y-4">
                <div className="bg-white rounded-lg shadow-md overflow-hidden mb-4">
                  <video
                    controls
                    className="w-full h-64 object-cover"
                    poster="https://public.readdy.ai/ai/img_res/29407ad9c2d07aac6714e5f326fef997.jpg"
                  >
                    <source
                      src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Teasing%20video/9e201229-2b75-4467-ab50-bf69c2799c3f.MP4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJUZWFzaW5nIHZpZGVvLzllMjAxMjI5LTJiNzUtNDQ2Ny1hYjUwLWJmNjljMjc5OWMzZi5NUDQiLCJpYXQiOjE3NjIyNzMyNTgsImV4cCI6MTc5MzgwOTI1OH0.Mu_toJOxyHwi7uNgZkbPnT8J8zpufHq9htGzF_7--rI"
                      type="video/mp4"
                    />
                    Votre navigateur ne supporte pas la lecture vidéo.
                  </video>
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Vidéo de présentation - Pavillon Afrique</h4>
                    <p className="text-sm text-gray-600">Découvrez l'ambiance unique du Pavillon Afrique</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                  <img
                    src="https://readdy.ai/api/search-image?query=African%20pavilion%20exhibition%20stand%20at%20international%20trade%20fair%20in%20Nantes%2C%20colorful%20African%20textiles%20and%20crafts%20displayed%2C%20professional%20booth%20setup%20with%20warm%20lighting%2C%20visitors%20browsing%20authentic%20African%20products%2C%20modern%20exhibition%20space%20with%20cultural%20decorations&width=300&height=200&seq=pav1&orientation=landscape"
                    alt="Stand d'exposition Pavillon Afrique"
                    className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                  />
                  <img
                    src="https://readdy.ai/api/search-image?query=African%20food%20stand%20at%20trade%20fair%2C%20traditional%20African%20cuisine%20being%20served%2C%20colorful%20spices%20and%20ingredients%20displayed%2C%20chef%20preparing%20authentic%20African%20dishes%2C%20warm%20inviting%20atmosphere%20with%20cultural%20decorations&width=300&height=200&seq=pav2&orientation=landscape"
                    alt="Stand restauration africaine"
                    className="w-full h-48 object-cover object-top rounded-lg shadow-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Statistics Section */}
        <section className="py-16 bg-orange-600 text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-4 gap-8 text-center">
              <div>
                <div className="text-4xl font-bold mb-2">58</div>
                <div className="text-orange-100">Publications Instagram</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">139</div>
                <div className="text-orange-100">Abonnés</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">50+</div>
                <div className="text-orange-100">Exposants</div>
              </div>
              <div>
                <div className="text-4xl font-bold mb-2">5000+</div>
                <div className="text-orange-100">Visiteurs</div>
              </div>
            </div>
          </div>
        </section>

        {/* Festival Afroverso Section */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1">
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                  <video
                    controls
                    className="w-full h-96 object-cover"
                    poster="https://readdy.ai/api/search-image?query=African%20cultural%20concert%20video%20thumbnail%2C%20live%20music%20performance%2C%20vibrant%20stage%20lighting%2C%20audience%20enjoying%20african%20music%2C%20professional%20concert%20videography%20style%2C%20warm%20colors&width=600&height=400&seq=festival-concert-video&orientation=landscape"
                  >
                    <source
                      src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Concert%201/Concert%201.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJDb25jZXJ0IDEvQ29uY2VydCAxLm1wNCIsImlhdCI6MTc2Mjc4NTgxOSwiZXhwIjoxNzk0MzIxODE5fQ.CjQrNK7_TPkUx6Xjl61kXYXBV1Aivl25086_RNZCfrc"
                      type="video/mp4"
                    />
                    Votre navigateur ne supporte pas la lecture vidéo.
                  </video>
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Concert Festival Afroverso</h4>
                    <p className="text-sm text-gray-600">Découvrez l'ambiance musicale unique du Festival Afroverso</p>
                  </div>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">Festival Afroverso</h2>
                <h3 className="text-xl text-orange-600 font-semibold mb-4">Célébration de la Créativité Africaine</h3>
                <p className="text-lg text-gray-700 mb-6">
                  Un festival unique qui célèbre la créativité africaine à travers la mode, la musique, l'art et l'innovation.
                  Le Festival Afroverso rassemble créateurs, artistes et innovateurs pour une expérience immersive
                  de la culture africaine contemporaine.
                </p>
                <div className="space-y-4 mb-8">
                  <div className="flex items-center space-x-3">
                    <i className="ri-music-line text-orange-600 text-xl"></i>
                    <span className="text-gray-700">Concerts live d'artistes africains émergents et confirmés</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-palette-line text-orange-600 text-xl"></i>
                    <span className="text-gray-700">Expositions d'art contemporain africain</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-lightbulb-line text-orange-600 text-xl"></i>
                    <span className="text-gray-700">Showcase d'innovations technologiques africaines</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <i className="ri-shopping-bag-line text-orange-600 text-xl"></i>
                    <span className="text-gray-700">Marché de créateurs et entrepreneurs africains</span>
                  </div>
                </div>
                <button
                  onClick={() => setShowAfversosoForm(true)}
                  className="bg-orange-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Besoin d'infos
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Afrovidedressing Section */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                  Afrovidedressing marché de la mode africaine responsable et circulaire
                </h2>
                <h3 className="text-xl text-orange-600 font-semibold mb-4">Boutiques Éphémères Africaines</h3>
                <p className="text-lg text-gray-700 mb-6">
                  Nos événements musicaux mettent en lumière la richesse et la diversité de la musique africaine contemporaine.
                  Des concerts intimistes aux grandes scènes, nous créons des moments uniques de partage culturel
                  qui rassemblent les communautés autour de la passion musicale.
                </p>
                <div className="grid md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <i className="ri-music-line text-orange-600 text-2xl mb-2"></i>
                    <h4 className="font-semibold text-gray-900 mb-1">Mode & Textile</h4>
                    <p className="text-sm text-gray-600">Vêtements et accessoires traditionnels</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <i className="ri-mic-line text-orange-600 text-2xl mb-2"></i>
                    <h4 className="font-semibold text-gray-900 mb-1">Art & Artisanat</h4>
                    <p className="text-sm text-gray-600">Oeuvres d'art et créations artisanales</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <i className="ri-headphone-line text-orange-600 text-2xl mb-2"></i>
                    <h4 className="font-semibold text-gray-900 mb-1">Bien-être</h4>
                    <p className="text-sm text-gray-600">Cosmétiques et produits naturels</p>
                  </div>
                  <div className="bg-white p-4 rounded-lg shadow-sm">
                    <i className="ri-group-line text-orange-600 text-2xl mb-2"></i>
                    <h4 className="font-semibold text-gray-900 mb-1">Décoration</h4>
                    <p className="text-sm text-gray-600">Objets déco et mobilier africain</p>
                  </div>
                </div>
              </div>
              <div>
                <div className="bg-white rounded-lg shadow-md overflow-hidden">
                  <video
                    controls
                    className="w-full h-96 object-cover"
                    poster="https://readdy.ai/api/search-image?query=African%20sustainable%20fashion%20video%20thumbnail%2C%20Afrovidedressing%20event%2C%20circular%20fashion%20market%2C%20colorful%20african%20clothing%2C%20eco-friendly%20fashion%20showcase%2C%20professional%20event%20videography%20style&width=600&height=400&seq=afrovidedressing-main-video&orientation=landscape"
                  >
                    <source
                      src="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Afrovidedressing%20video/WhatsApp%20Video%202025-11-10%20at%2014.11.49.mp4?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJBZnJvdmlkZWRyZXNzaW5nIHZpZGVvL1doYXRzQXBwIFZpZGVvIDIwMjUtMTEtMTAgYXQgMTQuMTEuNDkubXA0IiwiaWF0IjoxNzYyNzg2OTA5LCJleHAiOjE3OTQzMjI5MDl9.SwbtAF1akwqUw3P9tjScrkR_OLJOATDjj6V1dgNJwDY"
                      type="video/mp4"
                    />
                    Votre navigateur ne supporte pas la lecture vidéo.
                  </video>
                  <div className="p-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Afrovidedressing - Mode Circulaire</h4>
                    <p className="text-sm text-gray-600">Découvrez l'ambiance de notre marché de la mode africaine responsable et circulaire</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Forum Africa Eco Section */}
        <section id="forum-africa-eco" className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {/* Header */}
            <div className="text-center mb-12">
              <span className="inline-block bg-orange-100 text-orange-700 text-sm font-semibold px-4 py-1 rounded-full mb-4 uppercase tracking-wide">
                Événement économique
              </span>
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                Forum Africa Eco — L'Afrique à Nantes
              </h2>
              <h3 className="text-xl text-orange-600 font-semibold mb-6">
                Diaspora africaine · Entrepreneuriat · Investissement · Partenariats
              </h3>
              <div className="flex flex-wrap justify-center gap-2 mb-6">
                {['Entrepreneuriat africain','Diaspora africaine','Agroalimentaire','Immobilier','Finance','Innovation','Networking stratégique','Nantes'].map((tag) => (
                  <span key={tag} className="bg-orange-50 border border-orange-200 text-orange-700 text-xs px-3 py-1 rounded-full font-medium">
                    {tag}
                  </span>
                ))}
              </div>
            </div>

            {/* Images Gallery — première image en taille naturelle */}
            <div className="grid lg:grid-cols-3 gap-4 mb-12 items-start">
              <div className="lg:col-span-2 bg-gray-50 rounded-lg overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/7e669394-b5f9-413f-9283-76dab17ac034/6f1796e2-f17a-4108-a7b2-2f1bcc2d92da_WhatsApp-Image-2026-03-23-at-17.12.25-1.jpeg?v=6a4fc61c91127db5f348025ba558488b"
                  alt="Forum Africa Eco Nantes - Diaspora africaine et opportunités d'affaires"
                  className="w-full h-auto object-contain rounded-lg"
                />
              </div>
              <div className="flex flex-col gap-4">
                <div className="bg-gray-50 rounded-lg overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/7e669394-b5f9-413f-9283-76dab17ac034/20d7048b-343e-4043-bdb4-496f8b189fda_WhatsApp-Image-2026-03-23-at-17.12.25.jpeg?v=9398a9d68fd8e6ef9a52c8888d5b8ee8"
                    alt="Forum Africa Eco - Conférences et panels économiques"
                    className="w-full h-auto object-contain rounded-lg"
                  />
                </div>
                <div className="bg-gray-50 rounded-lg overflow-hidden">
                  <img
                    src="https://storage.readdy-site.link/project_files/7e669394-b5f9-413f-9283-76dab17ac034/4775fb4f-cc15-487c-a159-464977f12d7a_WhatsApp-Image-2026-03-23-at-17.11.45.jpeg?v=2322ab80dc3eaa395956a97b78e6920c"
                    alt="Forum Africa Eco - Networking et partenariats durables"
                    className="w-full h-auto object-contain rounded-lg"
                  />
                </div>
              </div>
            </div>

            {/* Content + CTA */}
            <div className="grid lg:grid-cols-3 gap-12 items-start">
              <div className="lg:col-span-2 space-y-4 text-gray-700 text-base leading-relaxed">
                <p>
                  Le <strong>Forum Africa Eco à Nantes</strong> est un événement économique majeur dédié à la <strong>diaspora africaine</strong> et aux opportunités d'affaires entre l'Afrique et la France. Organisé par Ideevents, ce forum réunit entrepreneurs, investisseurs et acteurs institutionnels engagés dans le développement économique africain.
                </p>
                <p>
                  À Nantes, ville ouverte sur le monde, le Forum Africa Eco valorise les initiatives innovantes issues de l'Afrique et de sa diaspora. Cet événement met en lumière des secteurs clés tels que l'<strong>entrepreneuriat africain</strong>, l'<strong>agroalimentaire</strong>, l'<strong>immobilier</strong>, la <strong>finance</strong> et l'<strong>innovation</strong>.
                </p>
                <p>
                  Il favorise les rencontres professionnelles, le <strong>networking stratégique</strong> et la création de partenariats durables. Le Forum Africa Eco s'impose comme un hub incontournable pour connecter la <strong>diaspora africaine en France</strong> avec les opportunités du continent africain.
                </p>
                <p>
                  À travers des <strong>conférences, panels et masterclass</strong>, les participants accèdent à des contenus à forte valeur ajoutée. Nantes devient ainsi un point de convergence entre talents africains, porteurs de projets et décideurs économiques.
                </p>
                <p>
                  Ce rendez-vous unique contribue au rayonnement de l'<strong>Afrique moderne, dynamique et tournée vers l'avenir</strong>. Rejoignez le Forum Africa Eco à Nantes pour bâtir ensemble les ponts économiques entre l'Afrique et sa diaspora.
                </p>
              </div>

              <div className="bg-orange-50 border border-orange-100 rounded-lg p-6 sticky top-24">
                <h4 className="font-bold text-gray-900 text-lg mb-4">Informations pratiques</h4>
                <div className="space-y-3 mb-6">
                  <div className="flex items-center space-x-3 text-sm text-gray-700">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full shrink-0">
                      <i className="ri-calendar-event-line text-orange-600"></i>
                    </div>
                    <span>Foire de Nantes 2026</span>
                  </div>
                  <div className="flex items-center space-x-3 text-sm text-gray-700">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full shrink-0">
                      <i className="ri-map-pin-line text-orange-600"></i>
                    </div>
                    <span>Nantes, France</span>
                  </div>
                  <div className="flex items-center space-x-3 text-sm text-gray-700">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full shrink-0">
                      <i className="ri-building-2-line text-orange-600"></i>
                    </div>
                    <span>Organisé par Ideevents</span>
                  </div>
                  <div className="flex items-center space-x-3 text-sm text-gray-700">
                    <div className="w-8 h-8 flex items-center justify-center bg-orange-100 rounded-full shrink-0">
                      <i className="ri-group-line text-orange-600"></i>
                    </div>
                    <span>Entrepreneurs · Investisseurs · Institutionnels</span>
                  </div>
                </div>
                <a
                  href="https://www.eventbrite.com/e/forum-africa-eco-foire-de-nantes-2026-tickets-1982438267223?aff=oddtdtcreator"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-orange-600 text-white text-center py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-ticket-line mr-2"></i>
                  S'inscrire à l'événement
                </a>
                <p className="text-xs text-gray-500 text-center mt-2">Via Eventbrite — Inscription sécurisée</p>
              </div>
            </div>
          </div>
        </section>

        {/* Call to Action */}
        <section className="py-20 bg-gradient-to-r from-orange-500 to-red-600 text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Participez à nos prochains événements
            </h2>
            <p className="text-xl mb-8">
              Rejoignez-nous pour célébrer la richesse culturelle africaine et découvrir
              des créateurs exceptionnels
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => setShowPavillonForm(true)}
                className="bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Besoin d'infos
              </button>
              <a
                href="https://dcneykqhasdgepewqshp.supabase.co/storage/v1/object/sign/Formulaire%20d'inscription%20Pavillon%20Afrique/1%20%20Fiche%20d'admission%202026.pdf?token=eyJraWQiOiJzdG9yYWdlLXVybC1zaWduaW5nLWtleV8xMThkNzZkZi1hNzc3LTRjYzEtYjAxMy1kMGViMzdkNmE2OGUiLCJhbGciOiJIUzI1NiJ9.eyJ1cmwiOiJGb3JtdWxhaXJlIGQnaW5zY3JpcHRpb24gUGF2aWxsb24gQWZyaXF1ZS8xICBGaWNoZSBkJ2FkbWlzc2lvbiAyMDI2LnBkZiIsImlhdCI6MTc2NjEzMTMxNSwiZXhwIjoxNzk3NjY3MzE1fQ.tOopjr6jpTLJmSfipqJYpBuk0SqKfho323z0SLibbtI"
                download="Fiche_admission_Pavillon_Afrique_2026.pdf"
                className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-orange-600 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                <i className="ri-download-line mr-2"></i>
                Télécharger le dossier
              </a>
            </div>
          </div>
        </section>
      </main>

      {/* Modal Formulaire Pavillon Afrique */}
      {showPavillonForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900">Besoin d'infos - Pavillon Afrique</h3>
                <button onClick={() => setShowPavillonForm(false)} className="text-gray-400 hover:text-gray-600">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              {pavillonSuccess ? (
                <div className="text-center py-8">
                  <i className="ri-check-circle-line text-green-500 text-6xl mb-4"></i>
                  <h4 className="text-xl font-semibold text-green-600 mb-2">Demande envoyée avec succès !</h4>
                  <p className="text-gray-600">Nous vous contacterons dans les plus brefs délais.</p>
                </div>
              ) : (
                <form onSubmit={handlePavillonSubmit} data-readdy-form id="pavillon-form">
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nom / Prénom *</label>
                      <input type="text" name="nom" value={pavillonFormData.nom} onChange={(e) => setPavillonFormData({ ...pavillonFormData, nom: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Structure / Entreprise *</label>
                      <input type="text" name="structure" value={pavillonFormData.structure} onChange={(e) => setPavillonFormData({ ...pavillonFormData, structure: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Activité / Secteur *</label>
                    <input type="text" name="activite" value={pavillonFormData.activite} onChange={(e) => setPavillonFormData({ ...pavillonFormData, activite: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Surface souhaitée (m²)</label>
                      <select name="surface" value={pavillonFormData.surface} onChange={(e) => setPavillonFormData({ ...pavillonFormData, surface: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm pr-8">
                        <option value="">Sélectionner</option>
                        <option value="6m²">6 m²</option>
                        <option value="9m²">9 m²</option>
                        <option value="12m²">12 m²</option>
                        <option value="18m²">18 m²</option>
                        <option value="24m²">24 m²</option>
                        <option value="Autre">Autre (préciser dans le message)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Contact *</label>
                      <input type="email" name="contact" value={pavillonFormData.contact} onChange={(e) => setPavillonFormData({ ...pavillonFormData, contact: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                    </div>
                  </div>
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Besoins techniques</label>
                    <textarea name="besoins" value={pavillonFormData.besoins} onChange={(e) => setPavillonFormData({ ...pavillonFormData, besoins: e.target.value.slice(0, 500) })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" rows={3} placeholder="Électricité, éclairage, mobilier..." maxLength={500} />
                    <p className="text-xs text-gray-500 mt-1">{pavillonFormData.besoins.length}/500 caractères</p>
                  </div>
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Message / Informations complémentaires</label>
                    <textarea name="message" value={pavillonFormData.message} onChange={(e) => setPavillonFormData({ ...pavillonFormData, message: e.target.value.slice(0, 500) })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" rows={4} maxLength={500} />
                    <p className="text-xs text-gray-500 mt-1">{pavillonFormData.message.length}/500 caractères</p>
                  </div>
                  <div className="flex gap-4">
                    <button type="button" onClick={() => setShowPavillonForm(false)} className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap">Annuler</button>
                    <button type="submit" disabled={pavillonSubmitting} className="flex-1 bg-orange-600 text-white px-6 py-3 rounded-md hover:bg-orange-700 transition-colors disabled:opacity-50 whitespace-nowrap">
                      {pavillonSubmitting ? 'Envoi...' : 'Envoyer la demande'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Formulaire Festival Afroverso */}
      {showAfversosoForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-2xl font-bold text-gray-900">Inscription Exposant/Créateur - Festival Afroverso</h3>
                <button onClick={() => setShowAfversosoForm(false)} className="text-gray-400 hover:text-gray-600">
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
              {afversosoSuccess ? (
                <div className="text-center py-8">
                  <i className="ri-check-circle-line text-green-500 text-6xl mb-4"></i>
                  <h4 className="text-xl font-semibold text-green-600 mb-2">Inscription envoyée avec succès !</h4>
                  <p className="text-gray-600">Nous vous contacterons dans les plus brefs délais pour confirmer votre participation.</p>
                </div>
              ) : (
                <form onSubmit={handleAfversosoSubmit} data-readdy-form id="afversoso-form">
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Nom / Prénom *</label>
                      <input type="text" name="nom" value={afversosoFormData.nom} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, nom: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Marque / Nom d'artiste *</label>
                      <input type="text" name="structure" value={afversosoFormData.structure} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, structure: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" required />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Domaine d'activité *</label>
                    <select name="activite" value={afversosoFormData.activite} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, activite: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm pr-8" required>
                      <option value="">Sélectionner</option>
                      <option value="Mode et textile">Mode et textile</option>
                      <option value="Afrovidedressing">Afrovidedressing (mode circulaire)</option>
                      <option value="Art contemporain">Art contemporain</option>
                      <option value="Artisanat traditionnel">Artisanat traditionnel</option>
                      <option value="Musique">Musique</option>
                      <option value="Innovation technologique">Innovation technologique</option>
                      <option value="Cosmétique naturelle">Cosmétique naturelle</option>
                      <option value="Alimentation">Alimentation</option>
                      <option value="Autre">Autre</option>
                    </select>
                  </div>
                  <div className="grid md:grid-cols-2 gap-4 mb-4">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Type de stand souhaité</label>
                      <select name="surface" value={afversosoFormData.surface} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, surface: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm pr-8">
                        <option value="">Sélectionner</option>
                        <option value="Stand 3m² - Créateur débutant">Stand 3m² - Créateur débutant</option>
                        <option value="Stand 6m² - Créateur confirmé">Stand 6m² - Créateur confirmé</option>
                        <option value="Stand 9m² - Marque établie">Stand 9m² - Marque établie</option>
                        <option value="Stand 12m² - Exposition premium">Stand 12m² - Exposition premium</option>
                        <option value="Espace performance - Artiste">Espace performance - Artiste</option>
                        <option value="Autre (préciser dans le message)">Autre (préciser dans le message)</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">Contact *</label>
                      <input type="email" name="contact" value={afversosoFormData.contact} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, contact: e.target.value })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" placeholder="Email de contact" required />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Besoins techniques et logistiques</label>
                    <textarea name="besoins" value={afversosoFormData.besoins} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, besoins: e.target.value.slice(0, 500) })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" rows={3} placeholder="Électricité, éclairage, mobilier, sonorisation..." maxLength={500} />
                    <p className="text-xs text-gray-500 mt-1">{afversosoFormData.besoins.length}/500 caractères</p>
                  </div>
                  <div className="mb-6">
                    <label className="block text-sm font-medium text-gray-700 mb-2">Présentation de votre projet / création</label>
                    <textarea name="message" value={afversosoFormData.message} onChange={(e) => setAfversosoFormData({ ...afversosoFormData, message: e.target.value.slice(0, 500) })} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm" rows={4} placeholder="Décrivez votre univers créatif, vos produits, votre démarche artistique..." maxLength={500} />
                    <p className="text-xs text-gray-500 mt-1">{afversosoFormData.message.length}/500 caractères</p>
                  </div>
                  <div className="flex gap-4">
                    <button type="button" onClick={() => setShowAfversosoForm(false)} className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors whitespace-nowrap">Annuler</button>
                    <button type="submit" disabled={afversosoSubmitting} className="flex-1 bg-orange-600 text-white px-6 py-3 rounded-md hover:bg-orange-700 transition-colors disabled:opacity-50 whitespace-nowrap">
                      {afversosoSubmitting ? 'Envoi...' : 'Envoyer'}
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
